const locale = {
    placeholder: 'நேரத்தைத் தேர்ந்தெடுக்கவும்',
    rangePlaceholder: ['தொடக்க நேரம்', 'முடிவு நேரம்'],
};
export default locale;
